"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineAddEnvVarsProcessor = void 0;
/**
 * The `add_env_vars` processor adds environment variable values to log events.
 */
class ObservabilityPipelineAddEnvVarsProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineAddEnvVarsProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineAddEnvVarsProcessor = ObservabilityPipelineAddEnvVarsProcessor;
/**
 * @ignore
 */
ObservabilityPipelineAddEnvVarsProcessor.attributeTypeMap = {
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineAddEnvVarsProcessorType",
        required: true,
    },
    variables: {
        baseName: "variables",
        type: "Array<ObservabilityPipelineAddEnvVarsProcessorVariable>",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineAddEnvVarsProcessor.js.map